"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function SvgLebanon(_ref) {
  var className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#F0F0F0",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 0C9.657 0 4.176 3.692 1.588 9.043h28.824C27.824 3.692 22.343 0 16 0zM16 32c6.343 0 11.824-3.692 14.412-9.044H1.588C4.176 28.308 9.657 32 16 32z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#6DA544",
    d: "M20.174 18.783L16 11.13l-4.174 7.653h3.13v2.087h2.088v-2.087z"
  })));
}

SvgLebanon.propTypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
SvgLebanon.defaultProps = {
  className: undefined,
  style: undefined
};
var _default = SvgLebanon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/PhoneInput/flags/Lebanon.js
// module id = TtOc
// module chunks = 0